// ---- components/Footer.js ----
export function Footer() {
  return (
    <footer className="bg-gray-200 dark:bg-gray-900 text-center py-6">
      <p className="text-gray-700 dark:text-gray-400">
        © {new Date().getFullYear()} Ethos Tech Hub Limited. All rights
        reserved.
      </p>
    </footer>
  );
}
